module.exports = __webpack_public_path__ + "static/media/example_sign.6a2bb4f0.jpg";